const langsEn = {
	language: 'English',
	advertisement: 'Advertisements',
	review: 'Approve',
	device: 'Devices',
	category: 'Categories',
	product: 'Products',
	goods: 'Goods',
	tags: 'Tags',
	contract: 'Comparisons',
	contractHealth: 'Health Comparisons',
	system: 'System',
	role: 'Roles',
	user: 'Users',
	authority: 'Authorities',
	authoritys: 'authority',
	logout: 'Logout',
	addAuthority: 'New Permission',
	addRole: 'New Role',
	editAuthority: 'Edit Permission',
	editRole: 'Edit Role',
	authorityName: 'Permissions',
	description: 'Description',
	action: 'Action',
	createDate: 'Creation Time',
	notData: 'No Data',
	edit: 'Edit',
	delete: 'Delete',
	inputAuthName: 'Please enter permission name',
	inputRoleName: 'Please enter role name',
	inputDescription: 'Please enter description',
	deleteSuccess: 'Delete Success ',
	addSuccess: 'Add Success ',
	updateSuccess: 'Update Success ',
	deleteFail: 'Delete Failed ',
	cancel: 'Cancel',
	save: 'Save',
	warning: 'Warning',
	deleteAuthority: 'Are you sure to delete this Authority?',
	requestTimeout: 'Request Timeout',
	requestFailed: 'Request Failed',
	pageItems: 'Total {total} Items',
	roleName: 'Role name',
	scope: 'Scope',
	deleteRole: 'Are you sure to delete this Role?',
	selectScope: 'Please select Scope',
	authEdit: 'Authority Edit',
	selectNumber: '{number} Selected',
	account: 'Account',
	accountType: 'Account Type',
	email: 'Email',
	phone: 'Phone',
	selectAccountType: 'Account Type',
	selectLeastOneRole: 'Select at least one role',
	addPermissionsRoleFirst: 'Please add authorities to the role first',
	selectLeastOnePermission: 'Select at least one authority',
	noParam: 'No Param',
	nameOrPassErr: 'Username or password error',
	dateDuplicate: 'Data Duplicate',
	mobilePhoneExists: 'Mobile phone already exists',
	paramError: 'PARAM_ERROR',
	alreadyApplyCancel: 'Already apply cancel',
	alreadyLoggedOff: 'Already logged off',
	roleNameAlreadyExists: 'Role name already exists',
	authorityNameAlreadyExists: 'Authority name already exists',
	theDataReferenced: 'The data is referenced',
	formatPhoneIncorrect: 'The format of the phone is incorrect',
	formatEmailIncorrect: 'The format of the email is incorrect',
	operationFailed: 'Operation failed',
	inconsistentPasswords: 'Inconsistent passwords',
	missingDefaultRoleGrade: 'Missing default role or grade',
	passwordComplexity: 'Cannot delete: the permission is used by roles.',
	userNotExits: 'Cannot delete: the role is used by user.',
	mustLeastEmailPhone: 'Must be at least one email and phone',
	userHasBoundPhone: 'The user has bound phone',
	userHasNoBoundPhone: 'The user has no bound phone',
	userHasBoundEmail: 'The user has bound email',
	userHasNoBoundEmail: 'The user has no bound email',
	sameNewAndOldEmail: 'The same new and old email',
	sameNewAndOldPhone: 'The same new and old phone',
	differentNewAndOldPhone: 'Different new and old phone',
	differentNewAndOldEmail: 'Different new and old email',
	oldAndNewPasswordsSame: 'The old and new passwords are the same',
	accountBlank: 'The account is blank',
	defaultRoleCannotEmpty: 'The default role cannot be empty',
	defaultGradeCannotEmpty: 'The default grade cannot be empty',
	accountIsIncorrect: 'The account is incorrect',
	recordIsDuplicate: 'The record is duplicate',
	azureTokenIsError: 'Azure token is error',
	azureTokenIsExpires: 'Azure token is expires',
	verificationCodeInvalid: 'Verification code invalid',
	cannotManipulateTheRecord: 'Cannot manipulate the record',
	recordDoesNotExist: 'The record does not exist',
	cannotRepeatSubmission: 'Cannot repeat submission within two minute',
	roleEdit: 'Role Edit',
	login: 'Login',
	loginSSO: 'Login with SSO',
	logoutSuccess: 'Logout Success',
	updateDate: 'Update Time',
	userManagement: 'Users',
	roleManagement: 'Roles',
	permissionsManagement: 'Permissions',
	permissionsName: 'Permissions name',
	rolesNew: 'Role',
	permissions: 'Permissions',
	selectPermissions: 'Please select permissions.',
	selectAppsRoles: 'Select apps and roles',
	applications: 'Applications',
	selectApplications: 'Please select applications.',
	roles: 'Roles',
	selectRoles: 'Please select roles.',
	users: 'User',
	protection: '数据保护声明',
	imprint: '版权说明',
	terms: '使用条款',
	applicationNameExcited: 'Application name is exists.',
	fileUploadFail: 'File upload fail',
	detectiveFail: 'Detective fail',
	roleNameExists: 'Role name already exists',
	defaultRoleCanNotNull: 'The default role cannot be empty',
	fileIsNull: 'File is null',
	baseImageIsNull: 'Base image is null',
	azureTokenError: 'Azure token is error',
	azureTokenExpires: 'Azure token is expires',
	unsupportFileType: 'Only supports images in PNG, JPG, and JPEG formats',
	moreThanSize: 'Base image is more than 5M',
};
export default langsEn;
